export default __webpack_public_path__ + "static/media/Kuthcheman Zugite Staff.c3dcad99.jpg";